import React, { useRef, useEffect, useState } from "react";
import LoadingSpinner from "../components/LoadingSpinner";

interface TagOption {
  id: number;
  name: string;
  photo_count: number;
}

interface TagFilterDropdownProps {
  tags: TagOption[];
  selectedTagIds: number[];
  onChange: (ids: number[], clickedId: number) => void;
  onClose: () => void;
  isLoading?: boolean;
  loadingItemId?: number | null;
}

const TagFilterDropdown: React.FC<TagFilterDropdownProps> = ({
  tags,
  selectedTagIds,
  onChange,
  onClose,
  isLoading = false,
  loadingItemId = null
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;

      if (ref.current?.contains(target)) return;

      if (target instanceof Element && target.closest(".mobile-filters-modal"))
        return;

      onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const filtered = (query.trim()
    ? tags.filter(t => t.name.toLowerCase().includes(query.toLowerCase()))
    : tags
  ).sort((a, b) => a.name.localeCompare(b.name));

  const toggle = (id: number) => {
    const newIds = selectedTagIds.includes(id)
      ? selectedTagIds.filter(x => x !== id)
      : [...selectedTagIds, id];
    onChange(newIds, id);
  };

  return (
    <div
      className="search-filter-dropdown search-filter-dropdown--list"
      ref={ref}
    >
      <div className="search-filter-dropdown__search">
        <i className="fa fa-search search-filter-dropdown__search-icon"></i>
        <input
          type="text"
          className="search-filter-dropdown__search-input"
          placeholder="Search tags"
          value={query}
          onChange={e => setQuery(e.target.value)}
          autoFocus
        />
      </div>
      <div className="search-filter-dropdown__list">
        {filtered.length === 0 ? (
          <div className="search-filter-dropdown__empty">No tags found</div>
        ) : (
          <ul className="check-radio checkmark search-filter-dropdown__checkbox-list">
            {filtered.map(tag => {
              const isSelected = selectedTagIds.includes(tag.id);
              const isLoadingThis = isLoading && loadingItemId === tag.id;
              return (
                <li key={tag.id}>
                  <label>
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => toggle(tag.id)}
                      disabled={isLoadingThis}
                    />
                    <span className="r-dot"></span>
                    <span className="r-desc">
                      #{tag.name}
                      {isLoadingThis && <LoadingSpinner />}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default TagFilterDropdown;
